import { EventAttendee } from 'app/shared/typings';
import { Event } from 'app/shared/typings/events';

import { hasEventEnded } from './hasEventEnded';

interface Props {
  event?: Event;
  eventAttendee?: EventAttendee;
  isPlusOneFlow?: boolean;
  visaPreSaleEligible?: boolean;
  canBypassVisaValidation?: boolean;
}

export const shouldRedirectToVisaOfferPage = ({
  event,
  eventAttendee,
  isPlusOneFlow,
  visaPreSaleEligible,
  canBypassVisaValidation,
}: Props) => {
  if (!event) {
    return false;
  }

  const currentDate = new Date().getTime();
  const startsAtTime = new Date(event.startsAt).getTime();
  const eventStarted = startsAtTime - currentDate < 0;
  const eventEnded = hasEventEnded(event.startsAt, event.endsAt);

  return (
    event?.onPresale &&
    !(visaPreSaleEligible || canBypassVisaValidation) &&
    !eventEnded &&
    !eventStarted &&
    !eventAttendee &&
    !isPlusOneFlow
  );
};
